import { render, staticRenderFns } from "./shopcar.vue?vue&type=template&id=5313b114&scoped=true&"
import script from "./shopcar.vue?vue&type=script&lang=js&"
export * from "./shopcar.vue?vue&type=script&lang=js&"
import style0 from "./shopcar.vue?vue&type=style&index=0&id=5313b114&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5313b114",
  null
  
)

export default component.exports